import React from "react";
import { AuthImage, Logo ,Elearning} from "../../assets/images";

import "./auth.css";
interface AuthLayoutComponentProps {
  title1?: string;
  title2?: string;
  title3?: string;
  children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutComponentProps> = ({
  title1,
  title2,
  title3,
  children,
}) => {
  return (
    <div className="auth-container">
      {/* Animated Background */}
      <div className="auth-background">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>
      </div>

      <div className="auth-content">
        {/* Left Section */}
        <div className="auth-left-section">
          <div className="auth-left-content">
            <div className="logo-container">
              <img src={Logo} alt="Mascotte" className="auth-logo" />
            </div>

            <div className="auth-title-container">
              <h1 className="auth-main-title">
                {title1}
              </h1>
              <h2 className="auth-sub-title">
                {title2}
              </h2>
              <p className="auth-description">{title3}</p>
            </div>

            <div className="auth-illustration-container">
              <div className="illustration-glow"></div>
              <img
                src={Elearning}
                alt="Illustration"
                className="auth-illustration"
              />
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="auth-right-section">
          <div className="auth-form-card">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
